import { LabelColor } from "../components/label";
import { CustomerTypes } from "../types";

export const invitationStatusLabel: Record<string, { label: string, color: LabelColor }> = {
    [CustomerTypes.OnboardingInvitationStatus.DONE]: {
        label: 'Done',
        color: 'success',
    },
    [CustomerTypes.OnboardingInvitationStatus.AWAITING]: {
        label: 'Awaiting',
        color: 'warning',
    },
    [CustomerTypes.OnboardingInvitationStatus.ERRORED]: {
        label: 'Expired',
        color: 'error',
    },
    [CustomerTypes.OnboardingInvitationStatus.OPENED]: {
        label: 'Started',
        color: 'primary',
    },
}